/**
 * Layout dispatcher: picks the right layout engine based on diagram type and structure.
 */

import type { IRGraph, LayoutResult } from '../types';
import { resolveLayoutConfig } from './layout-config';
import { swimlaneLayout } from './swimlane-layout';
import { dagreLayout } from './dagre-adapter';

export function layoutGraph(graph: IRGraph): LayoutResult {
  const config = resolveLayoutConfig(graph.diagramType, graph.direction);
  graph.direction = config.direction; // sync resolved direction back for downstream consumers

  // Use swimlane layout when any lanes exist (including General-only)
  if (graph.lanes.length > 0) {
    return swimlaneLayout(graph, config);
  }

  // For graphs with no lanes at all, use dagre
  return dagreLayout(graph, config);
}
